import { Flex, Box, Heading, Text } from "@radix-ui/themes";
import styles from "./card.module.css";
import { Link } from "~/components/RouterLink";
import { LinkCta } from "~/components/LinkCta";
import {
  Locale,
  type LocalizedStrings,
  useLocalization,
} from "~/components/localization/LocalizationProvider";

type Localization = {
  cta: string;
};

const englishLocalization: Localization = {
  cta: "Learn More",
};

const spanishLocalization: Localization = {
  cta: "Más información",
};

const localized: LocalizedStrings<Localization> = {
  [Locale.EN]: englishLocalization,
  [Locale.ES]: spanishLocalization,
};

export function Card({
  imageSrc,
  imageSrcSet,
  imageSizes,
  heading,
  description,
  alt,
  to,
}: {
  imageSrc: string;
  imageSrcSet?: string;
  imageSizes?: string;
  heading: string;
  description: string;
  alt: string;
  to: string;
}) {
  const getLocalization = useLocalization(localized);

  return (
    <Link className={styles.cardLink} to={to}>
      <Box position="relative" p="4">
        <Box
          position="absolute"
          left="0"
          bottom="0"
          className={styles.cardDecoration}
          height="200px"
          width="200px"
        ></Box>
        <Flex
          width="100%"
          height="100%"
          className={styles.cardContent}
          direction="column"
          gap="2"
        >
          <Box>
            <img
              className={styles.cardImage}
              src={imageSrc}
              srcSet={imageSrcSet}
              sizes={imageSizes}
              alt={alt}
              width="704"
              height="508"
              loading="lazy"
              decoding="async"
            />
          </Box>
          <Flex gap="5" direction="column" px="4" pb="7">
            <Flex direction="column" gap="3">
              <Heading
                as="h2"
                weight="bold"
                size="7"
                className={styles.cardHeading}
              >
                {heading}
              </Heading>
              <Text size="4" className={styles.cardText}>
                {description}
              </Text>
            </Flex>
            <Box width="fit-content">
              <LinkCta px="7" py="4">
                {getLocalization("cta")}
              </LinkCta>
            </Box>
          </Flex>
        </Flex>
      </Box>
    </Link>
  );
}
